import { modalActions } from "@context/modals";
import { toFarsiNumber } from "@utils/digits";
import { FC } from "react";
import { MODAL_TYPES } from "types/modals";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const CategoryMobile: FC = () => {
  const { activeFilters } = useExplorePreloadedData();

  if (!activeFilters) return <></>;

  const categoryLength = Object.entries(activeFilters)
    .filter(([filterName]) => filterName === "category_id")
    .reduce((curr, [, filterItem]) => curr + filterItem.filter_value.length, 0);

  const openCategoryFilter = () => {
    modalActions.addModal(MODAL_TYPES.EXPLORE_CATEGORY, {
      config: {
        hideCloseIcon: true,
        useMobileClassName: true,
        modalClassName: " !h-[100vh] max-h-svh",
      },
    });
  };
  return (
    <div className="py-4     border-b border-fds-divider">
      <div className="flex py-2.5 justify-between items-center">
        <p className="title-md-medium " onClick={openCategoryFilter}>
          دسته‌بندی
        </p>
        <p className="text-fds-tertiary title-sm" onClick={openCategoryFilter}>
          {categoryLength
            ? `${toFarsiNumber(categoryLength)} مورد`
            : "انتخاب کنید"}
        </p>
      </div>
    </div>
  );
};

export default CategoryMobile;
